export const changeFirstPassForm = [
    {
        cols: [
            {
                formGroup: 'changeFirstPassForm',
                class: 'col-12 col-lg-10',
                title: 'Has accedido con una contraseña temporal. Debes establecer tu nueva contraseña ',
                titleClass: 'form-title text-center title-change-first-pass'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 mx-auto col-lg-5',
                item: 'input',
                type: 'password',
                placeholder: 'Contraseña',
                inputClass: 'text-input',
                formControlName: 'password',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 mx-auto col-lg-5',
                item: 'input',
                type: 'password',
                placeholder: 'Repetir contraseña',
                inputClass: 'text-input',
                formControlName: 'confirmPassword',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 col-lg-5',
                item: 'button',
                type: 'regular',
                placeholder: 'Aceptar',
                inputClass: 'form-button btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
];
